import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import StyledInputProps from "../useInterfaces/MDinputInterface"

export default styled(TextField)<StyledInputProps>(({ theme, ownerState }) => {
  const { palette, functions } = theme;
  const { error, success, disabled, info } = ownerState ? ownerState : { error: false, success: false, disabled: false, info: true };
  const { grey, transparent, error: colorError, success: colorSuccess,info: colorinfo} = palette;
  const { pxToRem } = functions;
  //console.log(palette.grey[700])
  const labelColor =ownerState? ownerState.labelColor: palette.grey[700];
  // styles for the input with error={true}
  const errorStyles = () => ({
    backgroundImage: "",
    backgroundRepeat: "no-repeat",
    backgroundPosition: `right ${pxToRem(12)} center`,
    backgroundSize: `${pxToRem(16)} ${pxToRem(16)}`,

    "& .Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline, &:after": {
        borderColor: colorError.main,
      },
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: colorError.main,
    },
  });
  const infoStyles = () => ({
    backgroundImage: "",
    backgroundRepeat: "no-repeat",
    backgroundPosition: `right ${pxToRem(12)} center`,
    backgroundSize: `${pxToRem(16)} ${pxToRem(16)}`,

    "& .Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline, &:after": {
        borderColor: colorinfo.main,
      },
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: colorinfo.main,
    },
  });

  // styles for the input with success={true}
  const successStyles = () => ({
    backgroundImage:"",
    backgroundRepeat: "no-repeat",
    backgroundPosition: `right ${pxToRem(12)} center`,
    backgroundSize: `${pxToRem(16)} ${pxToRem(16)}`,

    "& .Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline, &:after": {
        borderColor: colorSuccess.main,
      },
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: colorSuccess.main,
    },
  });
  return {
    backgroundColor: disabled ? `${grey[200]} !important` : transparent.main,
    pointerEvents: disabled ? "none" : "auto",
    "& .MuiInputLabel-root": {
      color: labelColor, 
    },
    ...theme.components.MuiOutlinedInput.styleOverrides.inputSizeSmall,
    //backgroundColor: `${grey[200]} !important` ,
    ...(error && errorStyles()),
    ...(success && successStyles()),
    ...(info && infoStyles()),
  };
});
